import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SectionConfig } from '../section/section-config';
import { FlexModule } from '@ngbracket/ngx-layout';

import { SectionComponent } from '../section/section.component';
import { MatStep, MatStepper } from '@angular/material/stepper';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { SectionContentComponent } from '../section-content/section-content.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'recrewt-section-side-nav',
  templateUrl: './section-side-nav.component.html',
  styleUrls: ['./section-side-nav.component.scss'],
  imports: [
    FlexModule,
    SectionComponent,
    MatStepper,
    MatStep,
    ReactiveFormsModule,
    SectionContentComponent,
    TranslateModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionSideNavComponent {
  readonly sectionConfigs = input<SectionConfig[]>([]);

  readonly navtitle = input<string>();

  protected formGroupOf(conf: SectionConfig): FormGroup | null {
    const data = conf.data;
    if (
      data &&
      typeof data === 'object' &&
      'formGroup' in data &&
      data.formGroup instanceof FormGroup
    ) {
      return data.formGroup;
    }
    return null;
  }
}
